import { HeaderBackground, Logo } from 'config/emailTemplate';
import i18n from 'i18n';
import { getCountry } from './country';
import { setDateFormat } from './date';
import paths from 'constants/paths';
import searchParams from '../constants/searchParams';
import { getUrl } from './paths';

export const generateExternalNotificationEmailHtml = (
  recipient,
  assessmentName,
  accessedAt,
  assessmentId,
  accessKey,
) => {
  const url = getUrl(
    `${paths.clientConfiguration}/${assessmentId}?${searchParams.accessKey}=${accessKey}&${searchParams.activeTab}=2`,
  );

  return `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${i18n.t('externalAccess.emailTemplate.title')}</title>
        <style type="text/css">
        </style>
    </head>
    <body style="font-family: Source Sans Pro, Arial, sans-serif; font-size: 16px; line-height: 1.5; background-color: #FFF; padding: 0; margin: 0;">
        <table border="0" cellpadding="0" cellspacing="0" style="margin: 0 auto; background-color: #FFF;">
            <tr>
                <td class="header" style="background-color: #000; color: #FFF; text-align: left; max-height: 181px;">
                    <table width="100%" border="0" cellpadding="0" cellspacing="0">
                        <tr>
                            <td style="padding: 34px 34px 11px 45px;">
                                <img src="cid:logo" alt="Company Logo">							
                                <h1 style="margin-bottom: 0; font-style: normal; font-weight: 400; font-size: 32px; line-height: 40px;">${i18n.t(
                                  'externalAccess.emailTemplate.needsAssessment',
                                )}</h1>
                                <h3 style="color: #C0C6CE; font-style: normal; font-weight: 600; font-size: 14px; line-height: 18px;">${i18n.t(
                                  'externalAccess.emailTemplate.clientActivity',
                                )}</h3>
                            </td>
                            <td style="text-align: right; line-height: 1;">
                                <img class="background" style="" src="cid:background" alt="Background">	
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td class="content" style="padding: 50px; color: #3A3E43; font-family: 'Arial'; font-style: normal; font-weight: 400; font-size: 20px; line-height: 32px;">
                    <p>${i18n.t('externalAccess.emailTemplate.message1', {
                      recipient: recipient,
                    })}</p>		
                    <p>${i18n.t('externalAccess.emailTemplate.message2', {
                      assessmentName: assessmentName,
                      accessedAt: setDateFormat(accessedAt, getCountry()),
                      link1: `<a href="${url}" style="color: #3A3E43;">`,
                      link2: '</a>',
                    })}</p>		
                    <p>${i18n.t('externalAccess.emailTemplate.message3')}</p>		
                    <p>${i18n.t('externalAccess.emailTemplate.message4')}</p>
                </td>
            </tr>
            <tr>
                <td class="footer" style="height: 40px; background-color: #000; color: #FFF; padding: 30px; text-align: left; color: #C7CACE; font-family: 'Arial'; font-style: italic; font-weight: 400; font-size: 12px; line-height: 5px;">
                    <p>${i18n.t('externalAccess.emailTemplate.footer1')}</p>	
                    <p>${i18n.t('externalAccess.emailTemplate.footer2', {
                      link1:
                        '<a href="https://jll2.sharepoint.com/teams/ProductBrief-NeedsAssessment" style="color: #C7CACE;">',
                      link2: '</a>',
                    })}</p>
                </td>
            </tr>
        </table>
    </body>
    </html>
    `;
};

export const getExternalNotificationsAttachments = () => {
  return [
    {
      Content: HeaderBackground,
      Filename: 'background.png',
      Type: 'image/png',
      Disposition: 'inline',
      ContentId: 'background',
    },
    {
      Content: Logo,
      Filename: 'logo.png',
      Type: 'image/png',
      Disposition: 'inline',
      ContentId: 'logo',
    },
  ];
};
